module.exports = __webpack_public_path__ + "img/angle-up-solid.86ba8007.svg";